const fieldConstants = {
  emailDomain: 'Email Domain',
  age: 'Age',
  dob: 'Dob',
  gender: 'Gender',
  payingCustomer: 'paying_customer',
  capPayingCustomer: 'Paying Customer',
  company: 'Company',
  phone: 'Phone',
  phoneOption: 'phone_option',
  dateOperator: 'date_operator',
  createdOnDateOperator: 'created_date_operator',
  mobile: 'Mobile Number',
  region: 'Region',
  location: 'Location',
  source: 'Source',
  oriSource: 'Original Source',
  interest: 'Interest',
  formsSubmitted: 'Forms submitted',
  addedBy: 'Added by',
  createdOn: 'Created On',
  education: 'Education',
  occupation: 'Occupation',
  email: 'Email',
  sent: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  clicked: 'Clicked',
  not_delivered: 'Not delivered',
  not_opened: 'Not opened',
  not_clicked: 'Not clicked',
  campaign: 'campaign',
  product_purchased: 'Product Purchased',
  ltv: 'LTV',
  last_purchased: 'Last Purchased',
  order_id: 'Order ID',
  order_status: 'Order Status',
  order_date: 'Order Date',
  page_visited: 'Page Visited',
  pageVisitedTooltip: 'Contacts who visited a specific page',
  form_submitted: 'Form Submitted',
  formsSubmittedTooltip: 'Contacts who have submitted a specific form',
  inactive_since: 'Inactive Since',
  inactive_30day: 'Inactive',
  last_active: 'Last active',
  inactive: 'inactive',
  inactiveOperator: 'inactive_operator',
  inactive_since_tooltip: 'Contacts who were last active on',
  audienceTypeText: 'Target the right contacts using below filters',
  contactAttributes: 'Contacts Attributes',
  conactTooltip: 'Personal details',
  emailActivity: 'Email Activity',
  emailTooltip: 'How they interact with your emails',
  websiteActivity: 'Website Activity',
  websiteTooltip: 'What they do on your website',
  cartActivity: 'Cart Activity',
  cartTooltip: 'What they do on your cart',
  listActivity: 'List Activity',
  listTooltip: 'How many audiences present in list',
  ticketActivity: 'Ticket Activity',
  ticketTooltip: 'When ticket is purchased',
  transactionTooltip: 'Transaction Details',
  facebookActivity: 'Facebook Activity',
  facebookActivityTooltip: 'How many audiences present in facebook',
  factorealNav: 'Marketing Engine',
  factorealTooltip: 'Your contacts matching the criteria',
  facebookNav: 'Facebook',
  facebookTooltip: 'Facebook users matching some of your criteria',
  duplicateAudienceName: 'Audience name already in database, please select new name!',
  emptyErrorMsg: 'Please enter audience name',
  buildAudience: 'Build Audience',
  audienceLocalStore: 'localStoredAudience',
  member_of: 'Member Of',
  not_member_of: 'Not Member Of',
  routerChangeConfirmation: 'You have unsaved changes, are you sure you want to leave?',
  social_ads: "social_ad",
  journey_ad: 'social_ad_journey',
  facebook_ad: 'Facebook Ad',
  facebook_post: 'Facebook Post',
  fact_reserve_balance_limit: 10,
  fact_reserve_balance_limit_trial: 2,
  fb_connected_audience_message: 'Your facebook business account is connected with Marketing Engine',
  fb_not_connected_audience_message: 'Your Facebook business account is not connected please configure your Facebook business account ',
  add_comma_message: 'Enter comma(,) to add multiple values',
  journey_list: 'Journey List',
  campaign_list: 'Email Campaign',
  any_campaign: 'Any Email Campaign',
  any_journey: 'Any Journey Campaign',
  any_journey_whatsapp: 'Any Journey',
  any: 'any',
  any_campaign_url: 'Any Url',
  any_journey_url: 'Any Url',
  any_journey_email: 'Any Journey Email',
  inactive_default_audience_name: 'Inactive Default Audience',
  birthday_default_audience_name: 'Birthday Default Audience',
  registration_anniversary:'Registration Anniversary',
  cart_value: 'Cart Value',
  cart_single_value: 'cart_single_value',
  cart_between_min_value: 'cart_between_min_value',
  cart_between_max_value: 'cart_between_max_value',
  reentry_not_configured: 'Re-entry not configured for the journey',
  fb_user_attribute: 'User Attribute',
  user_fb_age: 'Age',
  user_fb_location: 'Location',
  user_fb_gender: 'Gender',
  user_fb_language: 'Language',
  user_fb_detailed_targeting: 'Detailed Targeting',
  location_include_exclude_error: 'You have to include at least one location before you can exclude locations',
  location_required_message: 'Your audience targeting is incomplete. Select at least one location.',
  age_gender_required_message: 'Your audience targeting is incomplete. Select age and gender.',
  fb_user_attribute_tooltip: 'Personal details',
  fb_potential_reach_tooltip: "This is an estimate of the size of the audience that's eligible to see your ad. It's based on your targeting criteria and  ad placements. This is not an estimate of how many people will actually see your ad, and the number may change over time",
  factoreal_potential_reach_tooltip: "This is an exact size of your contacts that's eligible to see your ad. It's based on the targeting criteria you select",
  factoreal_potential_reach_tooltip_anonymous:"This is an estimate of the size of your anonymous subscribers that will be reached. It's based on the targeting criteria you select. This number may change over time.",
  download_audience_tooltip: 'Click here to download contacts',
  zero_audience_download_error: "Audience size with applied filter is 0. Can't download with 0 contact.",
  failed_download: "Failed to download",
  download_fields: "No fields selected for download",
  fb_include_dt_label: 'Include people who match',
  fb_narrow_dt_label: 'People must match',
  fb_exclude_dt_label: 'Exclude people who match',
  smsActivity: 'Messaging activity',
  whatsappActivity: 'Whatsapp Activity',
  smsTooltip: 'How they interact with your SMS',
  whatsappTooltip: 'How they interact with your Whatsapp',
  any_sms: 'Any messaging Campaign',
  sms_templatename_exist: 'Template with same name already exists',
  sms_template_body: 'Please enter message body',
  sms_template_create: 'Successfully Created',
  sms_template_name_required: 'Please enter template name',
  sms_template_country_required: 'Please select atleast one target destination',
  sms_template_dlt_status_required: 'Please enter DLT Status',
  sms_template_dlt_template_id_required: 'Please enter DLT Template ID for India',
  sms_template_dlt_template_id_length : 'Length of DLT Template ID for India is not valid',
  sms_template_sender_id_required: 'Please enter Sender ID',
  sms_template_status_type_required: 'Please select Status Type',
  sms_template_sms_type_required: 'Please select SMS Template Type',
  sms_template_template_type_required: 'Please select Template Type',
  sms_template_delete: 'Successfully Deleted',
  sms_template_update: 'Successfully Updated',
  fb_custom_audience: 'Custom Audience',
  fb_custom_audience_tooltip: "Use Custom Audiences to reach people who've already interacted with your business",
  custom_fb_web_activity: 'Website Activity',
  custom_fb_insta: 'Instagram Business Profile Related Activity',
  custom_fb_page: 'Facebook Page Related Activity',
  custom_fb_video: 'Video',
  custom_fb_customer: 'Customer List',
  audience_count_err_msg: 'Audience definition is not available.',
  fb_website_activity_day_tooltip: "The number of days that people will remain in your audience after they engage with your content. People will be removed from your audience after the set time period unless they engage with the content again. Maximum time: 365 days Note: Data is available from Oct 2016. Choosing the maximum number of days will include people who engaged from that time and afters",
  fb_insta_day_tooltip: "The number of days that people will remain in your audience for after they engage with your content. People will be removed from your audience after the set time period unless they engage with the content again. Maximum time: 365 days. Note: Data is available from Jun 2017. Choosing the maximum number of days will include people who engaged from that time and after.",
  fb_page_day_tooltip: "The number of days that people will remain in your audience for after they engage with your content. People will be removed from your audience after the set time period unless they engage with the content again. Maximum time: 365 days. Note: Data is available from Oct 2016. Choosing the maximum number of days will include people who engaged from that time and after.",
  whatsapp_template_name_exist: 'Template name already taken.',
  whatsapp_template_body: 'Please enter message body',
  whatsapp_template_create: 'Successfully Created',
  whatsapp_template_delete: 'Successfully Deleted',
  whatsapp_template_update: 'Successfully Updated',
  sms_template_tooltip: 'SMS / MMS count will depend on the length of substituted values of merge tags and the type of characters used. SMS & MMS can have 160/153 latin american or 70/67 Unicode characters in a single/concatenated message',
  merge_tag_info:'Default value shows if a contact doesnt have a value for the field selected \n You can ask your admin to set the default value from settings.',
  device_user_attribute: 'Device Attribute',
  mobile_application: 'Mobile Attributes and Activity',
  app_attribute: 'App Attribute and Activity',
  app_attribute_tooltip: "How they interact with your app",
  device_attribute_tooltip: "Filters users based on their mobile device attributes",
  app_tooltip: "Filter users based on their mobile app attributes.",
  appActivity_tooltip: "Filter users based on actions performed by them within an app",
  push_tooltip: "All filters related to push notification related activities.",
  deviceType: "Filter users based on their mobile device type.",
  locationType: "Filter users based on their IP geolocation.",
  appName_tooltip: "Filter users based on the mobile app installed by them.",
  appVersion_tooltip: "Filter users based on the version of the mobile app installed by them.",
  push_subscribe: "Web Push Subscription,",
  web_push_notification: "Web Push Notification",
  last_push_date:"Filter users based on when they last recieved a push notification",
  push_sent:"Filter users based on if they were sent a push notification",
  push_opened:"Filter users based on if they opened a push notification",
  push_undelivered:"Filter users based on if a notification was not delivered to them",
  app_last_visit_date: "Filter users based on when they last visited an app",
  app_user_logged_in: "Filter users based on whether they have/haven't registered  into the app",
  app_installation_date: "Filter users based on when they installed an app",
  SignUpDeactivateTooltip: 'Your account is not approved yet. Please contact me-support@satisfilabs.com',
  tfa_msg: "Two-Factor authentication increases the security of your Marketing Engine account. If enabled, when users try to login to your Marketing Engine account, they will receive an email with code. This code has to be entered along with Userid and Password for a successful login.",
  tfa_info: "Your account is protected with two-factor authentication. We have sent you an email with the code. Please enter the code below.",
  tfa_tooltip: "2FA code is sent to your registered email address from no-reply@satisfilabs.com .If you don’t find the email in your inbox, do check your Spam folder.",
  disable_alert: "This Audience was built with a deprecated version of Audience Builder. Please contact support if you wish to continue using this audience.",
  contact_download_header: 'Contact Attributes',
  contact_download_table: 'Contact_Master',
  order_download_json: {
    header: "Order Details",
    tableName: "Orders",
    availableFields: ['title','product_id','factoreal_order_source','shopify_order_id','fulfillment_status','total_price'],
    linkingKey: 'shopify_customer_id'
 },
 auto_potential_reach_tooltip:"This is an exact size of your contacts that's eligible to see your ad. It's based on the targeting criteria you select",
 lookalike_source_note:"Please ensure that the source that you define includes at least 100 contacts in the same country.",
 customer_list_note:"Please select either one from meta audience tab or any combination from Audience and list tab",
 number_of_audience_message:"A 1% lookalike consists of the people most similar to your lookalike audience source. Increasing the percentage creates a bigger, broader audience.",
 userAttr_tooltip:"Define an audience based on criteria such as age, gender, interests, geography and more",
 custom_tooltip:"Use custom audiences to reach people who've already interacted with your business",
 lookalike_tooltip:"Reach new people who are likely to be interested in your business because they share similar characteristics to your existing customers",
 customerlist_info_la:"Target people who are similar to any audience or customer list in Marketing Engine.",
 pages_info:"Target people who are similar to those who follow or have interacted with your page.",
 pixel_info:"Target people who are similar to those who have visited your website and tailor further based on the events that you want to focus on like purchases, adding to cart, complete registration, etc.",
 catalogue_info:"Target people who are similar to those who have interacted with your product catalogue on your store or Facebook.",
 newlookalike_info:"The name that you define while saving the audience will be appended to each of the below mentioned lookalike audience names",
 source_info:"Define a source audience that your lookalike audience should be based on.",
 website_activity_info:"Create an audience based on website visitors from your Meta pixel and Tailor your audience based on events that you want to focus on such as purchases",
 instagram_business_profile_related_activity_info:"Create an audience of people who visited or interacted with your Instagram profile, posts or ads",
 facebook_page_related_activity:"Create an audience of people who follow or have interacted with your page",
 customer_list_info:"Create an audience by selecting from already existing audience/ list who have interacted with your business",
 event_info:"Choose an event that represents high customer intent and has an associated value, such as purchases",
 meta_aud_info:"Please select either one from meta audience tab or any combination from Audience and list tab",
 auto_segments_audiences_list: [
    'Auto_Profile_Adults',
    'Auto_Profile_Kids',
    'Auto_Profile_Senior_Citizens',
    'Auto_Profile_No_Age_Info',
    'Auto_Profile_All_Males',
    'Auto_Profile_All_Females',
    'Auto_Profile_All_Others',
    'Auto_Profile_All_Males_And_Females',
    'Auto_Profile_Top_Locations',
    'Auto_Profile_All_CXOs',
    'Auto_Profile_All_Directors_Above',
    'Auto_Profile_Top_Interests',
    'Auto_Profile_Today_Birthday_List',
    'Auto_Profile_Tomorrow_Birthday_List',
    'Auto_Profile_This_Month_Birthday_List',
    'Auto_Buyer_One_Time_Purchasers',
    'Auto_Buyer_Repeat_Purchasers',
    'Auto_Buyer_Top_Spenders',
    'Auto_Buyer_Bottom_Spenders',
    'Auto_Buyer_Top_Average_Order_Size',
    'Auto_Buyer_Bought_Top_Performing_Product',
    'Auto_Buyer_Dormant_Customers',
    'Auto_Buyer_Infrequent_Buyers',
    'Auto_Buyer_Regular_Customers',
    'Auto_Buyer_Top_Products',
    'Auto_Buyer_Bought_Popular_Products',
    'Auto_Buyer_Top_Purchasers',
    'Auto_Buyer_Email_Optins',
    'Auto_Buyer_SMS_Optins',
    'Auto_Buyer_Whatsapp_Optins',
    'Auto_Behaviour_Email_Actives',
    'Auto_Behaviour_Email_Inactives',
    'Auto_Behaviour_Email_Hyper_Actives',
    'Auto_Behaviour_SMS_Actives',
    'Auto_Behaviour_SMS_Inactives',
    'Auto_Behaviour_SMS_Hyper_Actives',
    'Auto_Behaviour_Frequent_App_Users',
    'Auto_Behaviour_Inactive_App_Users',
    'Auto_Behaviour_Top_App_Users',
    'Auto_Behaviour_Frequent_Website_Visitors',
    'Auto_Behaviour_Inactive_Website_Visitors',
    'Auto_Behaviour_Top_Time_Spenders_Website',
    'Auto_Behaviour_Overall_Inactives',
    'Auto_Behaviour_Email_Affinity_Customers',
    'Auto_Behaviour_SMS_Affinity_Customers',
    'Auto_Behaviour_Mobile_App_Affinity_Customers',
    'Auto_Behaviour_Cart_Abandoners',
    'Auto_Behaviour_Dormant_Email_Users',
    'Auto_Behaviour_Dormant_SMS_Users',
    'Auto_Behaviour_Dormant_Whatsapp_Users',
    'Auto_Behaviour_Dormant_Mobilepush_Users',
    'Auto_Behaviour_Dormant_Webpush_Users',
    'Auto_Behaviour_Recent_Email_Users',
    'Auto_Behaviour_Recent_SMS_Users',
    'Auto_Behaviour_Recent_Whatsapp_Users',
    'Auto_Behaviour_Recent_Mobilepush_Users',
    'Auto_Behaviour_Recent_Webpush_Users'
  ]
}
export default fieldConstants;
